export default __webpack_public_path__ + "static/media/setting.368fb64e.svg";